import(/* webpackMode: "eager" */ "/Users/altahan/Desktop/trq/trq_age/app/[locale]/page.tsx");
